import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import readCsrfToken from "shared/utils/readCsrfToken";

// Reads the token per request rather than once at client construction. EC
// sessions are long-lived and Devise rotates the token on re-authentication;
// baking it into static HttpLink headers means every later mutation 422s until
// the page is reloaded.
const csrfLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: { ...headers, "X-CSRF-Token": readCsrfToken() },
  }));
  return forward(operation);
});

export function createApolloClient() {
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    // Placeholder. Real handling arrives with the first consumer: GraphQL errors
    // ride in the response with HTTP 200, so they must not be treated as success.
    if (graphQLErrors) console.warn("[EC GraphQL errors]", graphQLErrors);
    if (networkError) console.warn("[EC network error]", networkError);
  });

  const httpLink = new HttpLink({
    uri: "/ec/graphql",
    credentials: "same-origin",
  });

  return new ApolloClient({
    link: from([csrfLink, errorLink, httpLink]),
    cache: new InMemoryCache(),
  });
}

// Module singleton. The epics are not React, so there is no provider to hang the
// client off; EC fetches once per session and never refetches, so one client for
// the page lifetime is all that is needed.
let client = null;

export function getApolloClient() {
  if (!client) client = createApolloClient();
  return client;
}
